<template>
    <div class="contains">
        <Header />
        <router-view />
        <Footer />
    </div>
</template>

<script setup>
import { onMounted, onUnmounted } from 'vue';
import Header from './components/Header/Header.vue';
import Footer from './components/Footer/Footer.vue';
import API from '@/utils/request';
import { useStore } from 'vuex'
const store = useStore()

const resizeHandler = () => {
    // 处理窗口大小改变后的逻辑
    if (window.innerWidth <= 930) {
        store.commit('setPlatform', 'H5');
    } else {
        store.commit('setPlatform', 'PC');
    }
};

const getWebsiteInit = () => {
    let obj = {};
    API.getRequest('ad/list', {}, (res) => {
        let datas = res.data;
        for (let i in datas) {
            obj[datas[i].position] = datas[i].imageUrl;
        }
        store.commit('setWebsiteData', obj);
    })
}

onMounted(() => {
    if (localStorage.getItem('token')) {
        store.commit('setToken', localStorage.getItem('token'));
    }
    getWebsiteInit();
    resizeHandler();
    window.addEventListener('resize', resizeHandler);
})

onUnmounted(() => {
    window.removeEventListener('resize', resizeHandler);
})
</script>

<style scoped lang="sass">


</style>
